// extracted by mini-css-extract-plugin
export default {"zoomControls":"O--z","zoomControlButton":"P--z","zoomBanner":"Q--z","bannerButton":"R--z","imageButton":"S--z","zoom":"T--z","zoomContent":"U--z"};